import React from "react";
import RetoGraph from "./RETO.jsx";
import RetiGraph from "./RETI.jsx";
import PDGraph from "./PD.jsx";
import OTGraph from "./OT.jsx";
import OSGraph from "./OS.jsx";
import ODFLGraph from "./ODFL.jsx";
import ETGraph from "./ET.jsx";
import EPMGraph from "./EPM.jsx";
import EMOGraph from "./EMO.jsx";
import EFGraph from "./EF.jsx";
import EAEUGraph from "./EAEU.jsx";
import DFAGraph from "./DFA.jsx";
import CDGraph from "./CD.jsx";
import ESMGraph from "./ESM.jsx";
import ESGUGraph from "./ESGU.jsx";
import ESFOCGraph from "./ESFOC.jsx";
import OBLGraph from "./OBL.jsx";
import ODGraph from "./OD.jsx";
import ITCGraph from "./ITC.jsx";
import MTUGraph from "./MTU.jsx";
import ODGUGraph from "./ODGU.jsx";
import OTDGraph from "./OTD.jsx";
import OFMGraph from "./OFM.jsx";
import HQDSGraph from "./HQDS.jsx";
import SESGraph from "./SES.jsx";
import SETIGraph from "./SETI.jsx";

export const Graph = (props) => {
  const { acronym, ...rest } = props;
  const selectedAcronym = acronym.split(":")[0]; // In case of group:behaviour format, take the group code for graph selection
  switch (selectedAcronym) {
    case "RETO":
      return <RetoGraph {...props} />;
    case "RETI":
      return <RetiGraph {...props} />;
    case "PD":
      return <PDGraph {...props} />;
    case "OT":
      return <OTGraph {...props} />;
    case "OS":
      return <OSGraph {...props} />;
    case "ODFL":
      return <ODFLGraph {...props} />;
    case "ET":
      return <ETGraph {...props} />;
    case "EPM":
      return <EPMGraph {...props} />;
    case "EMO":
      return <EMOGraph {...props} />;
    case "EF":
      return <EFGraph {...props} />;
    case "EAEU":
      return <EAEUGraph {...props} />;
    case "DFA":
      return <DFAGraph {...props} />;
    case "CD":
      return <CDGraph {...props} />;
    case "ESM":
      return <ESMGraph {...props} />;
    case "ESGU":
      return <ESGUGraph {...props} />;
    case "ESFOC":
      return <ESFOCGraph {...props} />;
    case "OBL":
      return <OBLGraph {...props} />;
    case "OD":
      return <ODGraph {...props} />;
    case "ITC":
      return <ITCGraph {...props} />;
    case "MTU":
      return <MTUGraph {...props} />;
    case "ODGU":
      return <ODGUGraph {...props} />;
    case "OTD":
      return <OTDGraph {...props} />;
    case "OFM":
      return <OFMGraph {...props} />;
    case "HQDS":
      return <HQDSGraph {...props} />;
    case "SES":
      return <SESGraph {...props} />;
    case "SETI":
      return <SETIGraph {...props} />;
    default:
      return (
        <div className="relative text-center my-6 mx-auto text-2xl">
          {props.missingDataMsg}
        </div>
      );
  }
};
